import Vue from 'vue'
import VueRouter from 'vue-router'
import util from '../assets/js/util'
import store from '../store/index'
import dsBridge from '@/api/dsbridge.js'
import axios from 'axios'
import api from '@/api/api.js'
import error from '../views/error/index'

let UTLPATH = process.env.UTLPATH;

import {
	Toast
} from 'vant'

Vue.use(VueRouter)

import mainRouter from './mainRouter.js' 


let userInfo=null;
 if(util.hasNative()){
	 userInfo = dsBridge.dsCall('getUserInfo', '');			 
 }else{
	 userInfo = sessionStorage.getItem('SET_USER') || null;	
	 if(userInfo){
		 userInfo = JSON.parse(userInfo)
	 }		   
 }
 if(!store.state.user && userInfo){
	store.commit('SET_USER', userInfo);
 }

const router = new VueRouter({
	mode: 'history',
	base: '/dc-h5s/childrenFront/',
	routes: [...mainRouter]
})
router.historyList = [];
router.beforeEach(async (to, form, next) => {
	
	if(to.path!='/'){
		let resTime = await axios.get(api.getSysConfig);
		let newTime = resTime.data && resTime.data.data &&resTime.data.data.currentTime;  //服务器当前时间
		if(!newTime || newTime ==''){
			console.log('未获取到服务器时间,活动也结束');
			next({ // 活动结束跳转到首页
				path: '/',
				replace: true
			})
			return
		};
		let endTimes_ = resTime.data.data.activityEndTime;   //活动结束时间
		if(endTimes_ <= newTime){
			console.log('活动已结束');
			next({ // 活动结束跳转到首页
				path: '/',
				replace: true
			})
			return
		}
	}	
	
	
	
	
	
	try {
		if (to.path) {
			_hmt.push(['_trackPageview', `/dc-h5s/${UTLPATH}` + to.fullPath + '/']);
			_hmts.push(['_trackPageview', `/dc-h5s/${UTLPATH}` + to.fullPath + '/']);
			_hmtss.push(['_trackPageview', `/dc-h5s/${UTLPATH}` + to.fullPath + '/']);
		}
	} catch (e) {
		console.log('埋点调用失败,可能是第一次')
	}

	if (!to.matched.length) { // 是否能找到页面
		next({ // 找不到页面进入应急的404页面
			path: '/',
			replace: true
		})
	} else {
		if( (!store.state.userId || store.state.userId=='000000') && to.path == '/playGame'){  //没登入的拦截
			next({ 
				path: '/',
				replace: true
			})
			return
		}
		
		
		let option = {};
		option.title = '疫情过后测一测，你敢说对娃有真爱吗？';
		option.desc = '参与测试100%中奖！vivo 手机、外教课程等你拿 ';
		if (!util.hasNative() && util.isEquipment().isWeixin) { //不在app里并且在微信里面才去执行
			util.getLoader('/', option);
		} else if (util.hasNative()) {
			let urls = util.getUrl();
			dsBridge.dsShare({
				link: urls,
				title: option.title,
				summary: option.desc
			});
		}
		util.setTitle(to.meta.title); //设置页面的title

		next();
	}
})




router.afterEach((to, from) => {
	router.historyList.push(to.path);
	document.getElementsByClassName('Router')[0] ? document.getElementsByClassName('Router')[0].scrollTop = 0 : '';
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js